
import { ColumnDefinitions } from "../../../../utils/dataGrid";

import { DateCell } from "../cells/dateCell/dateCell";
import DefaultCell from "../cells/defaultCell/defaultCell";
import TenantLinkCell from "../cells/tenantLinkCell/tenantLinkCell";
import TenantNameCell from "../cells/tenantNameCell/tenantNameCell";

import { TenantListViewModel } from "./tenantList.model";


const TenantListConfig: {
    columnDefinitions: ColumnDefinitions<TenantListViewModel>;
} = {
    columnDefinitions: [
        {
            dataField: 'tenantName',
            caption: 'Tenant Name',
            cellComponent: TenantNameCell,
        },
        {
            dataField: 'plan',
            caption: 'Plan',
            cellComponent: DefaultCell
        },
        {
            dataField: 'licenseValid',
            caption: 'License Valid Until',
            dataType: 'date',
            cellComponent: DateCell
        },
        {
            dataField: 'totalUsers',
            caption: 'Total Users',
            cellComponent: DefaultCell
        },
        {
            dataField: 'licensedUsers',
            caption: 'Licensed Users',
            cellComponent: DefaultCell
        },
        {
            dataField: 'url',
            caption: '',
            cellComponent: TenantLinkCell,
            hasFilter: false
        }
    ]
}

export default TenantListConfig;